import React from "react"
import PropTypes from "prop-types"
import ContentBlock from "components/ContentBlock"
import Metadata from "components/Metadata"
import Hero from "components/Hero"
import FooterLinkBlock from "components/FooterLinkBlock"
import AnchorNav from "components/AnchorNav"
import SurveyBlock from "components/blocks/SurveyBlock"

const ContentPage = ({
  metadata,
  hero,
  heroSize,
  content,
  linksBlock,
  showAnchorNav,
  anchorNavItems,
  surveyBlock,
}) => {
  const consCount = content.reduce((cons, { _type }, index) => {
    cons.push(
      index > 0 && content[index - 1]._type === _type ? cons[index - 1] + 1 : 1
    )
    return cons
  }, [])
  let nextSectionIdFallback = "global-footer"
  if (linksBlock) {
    nextSectionIdFallback = "footer-links"
  } else if (surveyBlock) {
    nextSectionIdFallback = "survey-block"
  }
  return (
    <>
      <Metadata {...metadata} />

      {hero && <Hero {...hero} size={heroSize} />}

      {content.map(({ _key, _type, __typename, ...props }, index) => (
        <ContentBlock
          key={_key}
          type={_type}
          content={props}
          context={{
            index,
            blockCount: content.length,
            key: _key,
            type: _type,
            lastType: index > 0 ? content[index - 1]._type : undefined,
            nextSectionId: content[index + 1] ? `section-${content[index + 1]._key}` : nextSectionIdFallback,
            nthConsecutiveOfType: consCount[index],
          }}
        />
      ))}

      {showAnchorNav && anchorNavItems?.length && (
        <AnchorNav sections={anchorNavItems} />
      )}
      {linksBlock && <FooterLinkBlock {...linksBlock} />}

      {surveyBlock && <SurveyBlock {...surveyBlock} />}
    </>
  )
}

export default ContentPage

ContentPage.propTypes = {
  metadata: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.shape({
      asset: PropTypes.shape({ _id: PropTypes.string.isRequired }).isRequired,
      hotspot: PropTypes.object,
      crop: PropTypes.object,
    }),
  }).isRequired,
  hero: PropTypes.shape({
    title: PropTypes.string.isRequired,
    background: PropTypes.object,
  }),
  heroSize: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      _type: PropTypes.string.isRequired,
      _key: PropTypes.string.isRequired,
    })
  ).isRequired,
  linksBlock: PropTypes.shape(FooterLinkBlock.propTypes),
  showAnchorNav: PropTypes.bool,
  anchorNavItems: PropTypes.array,
  surveyBlock: PropTypes.shape({
    title: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    inlineSurvey: PropTypes.shape({ url: PropTypes.string.isRequired })
      .isRequired,
    popupSurvey: PropTypes.shape({ url: PropTypes.string.isRequired })
      .isRequired,
  }),
}
